<template>
  <div>
    <b-row>
      <IBSRegimeFormMessage />
    </b-row>
    <b-row>
      <b-col lg="12">
        <h4>Geral</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="2">
        <InputMoney label="Total R$" disabled :precision="2" :value="vNFTot" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="BC IBS/CBS" disabled :precision="2" :value="vBCIBSCBS" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="Total IS" disabled :precision="2" :value="vIS" />
      </b-col>
    </b-row>
    <CBSTaxes :IbsTaxRegimeTotals="IbsTaxRegimeTotals" />
    <IBSTaxes :IbsTaxRegimeTotals="IbsTaxRegimeTotals" />
  </div>
</template>

<script>
import { InputMoney } from '@/components/Form';
import IBSRegimeFormMessage from '../../pages/IBSRegimeFormMessage.vue';
import IBSTaxes from './IBSTaxes.vue';
import CBSTaxes from './CBSTaxes.vue';

export default {
  name: 'IBSRegimeTaxesData',
  components: {
    IBSTaxes,
    CBSTaxes,
    InputMoney,
    IBSRegimeFormMessage,
  },
  props: {
    IbsTaxRegimeTotals: {
      type: Object,
      required: true,
    },
  },
  computed: {
    vNFTot() {
      return this.IbsTaxRegimeTotals?.vNFTot || 0;
    },
    vBCIBSCBS() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.vBCIBSCBS || 0;
    },
    vIS() {
      return this.IbsTaxRegimeTotals?.ISTot?.vIS || 0;
    },
  },
};
</script>
